@if (loading) {
  <div class="as-fixed-loader">
    <ng-lottie width="150px" height="150px" [options]="options"> </ng-lottie>
    <mat-label class="as-roboto-slab as-font-bold as-font-20 as-font-red">
      {{ "GENERAL.adding" | translate }}...
    </mat-label>
  </div>
}
<div class="as-lists-container">
  <div class="as-row as-justify-end">
    <mat-icon
      svgIcon="ic-close-green"
      class="as-pointer"
      mat-dialog-close
    ></mat-icon>
  </div>
  <p class="as-font-black-gray as-roboto-slab as-font-18 as-font-bold title">
    {{ "LISTS.addProductsToList" | translate }}
  </p>
  <p class="as-font-16 as-font subtitle">
    {{ "LISTS.addProductSelected" | translate }}
  </p>

  @if (listLoading) {
    <div class="as-spinner-green">
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>
  }
  @if (!listLoading) {
    <div class="as-favourites-container">
      <div class="favourites as-pointer">
        <p>{{ favouritesList.name }}</p>
        <div class="cont">
          <p>{{ favouritesCountItems }} productos</p>
          <mat-checkbox
            (change)="addToAddList()"
            [checked]="addProductToFavourites"
            color="accent"
            >
          </mat-checkbox>
        </div>
      </div>
      @for (item of myLists; track item; let i = $index) {
        <div>
          <div class="favourites as-pointer">
            <p>
              {{ item.name | titlecase | slice : 0 : 25
              }}{{ item.name.length > 25 ? "..." : "" }}
            </p>
            <div class="cont">
              <p>{{ item?.count }} productos</p>
              <mat-checkbox
                (change)="selectList(item.list_id, i)"
                [checked]="item.selected"
                color="accent"
                >
              </mat-checkbox>
            </div>
          </div>
        </div>
      }
    </div>
  }

  <div class="btn-container">
    <div class="new-list as-pointer">
      <mat-icon (click)="openCreateListModal()" svgIcon="ic-plus"></mat-icon>
      <p
        (click)="openCreateListModal()"
        class="as-font as-font-14 as-font-green as-font-underline"
        >
        {{ "LISTS.newList" | translate }}
      </p>
    </div>
    <div class="buttons">
      <button mat-dialog-close class="as-pointer as-font as-font-16">
        Cancelar
      </button>
      <button
        [disabled]="!addProductToFavourites && listsForAddProducts.length <= 0"
        (click)="addProductToList()"
        mat-flat-button
        color="accent"
        class="as-pointer as-font as-font-16"
        >
        {{ "LISTS.addProd" | translate }}
      </button>
    </div>
  </div>
</div>
